import { MainLayout, SectionLayout } from "../layouts";
import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import BannerPage from "../components/BannerPage";

export default function PageUnderDevelopment({
  title,
  subtitle,
  description,
  ctaLabel,
  ctaHref = "/",
}) {
  const location = useLocation();
  const finalTitle = "Halaman Sedang Dikembangkan";
  const finalDescription =
    "Maaf, halaman ini belum tersedia. Silakan kembali nanti atau hubungi administrator untuk informasi lebih lanjut.";
  const finalCtaLabel = "Kembali ke Beranda";

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [location.pathname]);

  return (
    <MainLayout title={finalTitle + " - MA Idrisiyyah"}>
      <BannerPage title={finalTitle} subtitle={subtitle} />

      <SectionLayout title={finalTitle}>
        <div className="flex items-center justify-center py-12">
          <div className="w-full max-w-2xl bg-white dark:bg-neutral-800 rounded-2xl shadow-sm border border-neutral-100 dark:border-neutral-700 p-10 text-center">
            <h2 className="text-2xl font-bold mb-3 text-neutral-800 dark:text-neutral-100">
              {finalTitle}
            </h2>
            <p className="text-neutral-500 dark:text-neutral-400 text-sm leading-relaxed mb-6">
              {finalDescription}
            </p>

            <Link
              to={ctaHref}
              className="inline-block px-6 py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-medium transition-colors"
            >
              {finalCtaLabel}
            </Link>

            <p className="mt-5 text-xs text-neutral-400 dark:text-neutral-500">
              Atau kembali ke halaman sebelumnya jika diinginkan.
            </p>
          </div>
        </div>
      </SectionLayout>
    </MainLayout>
  );
}
